import 'core-js/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import HttpsRedirect from 'react-https-redirect';
import App from './App';
import { Honeybadger, HoneybadgerErrorBoundary } from '@honeybadger-io/react';
import config from 'config';

const honeybadger = Honeybadger.configure({
    apiKey: config.honeybadger.key,
    environment: config.honeybadger.environment,
});

ReactDOM.render(
    <HttpsRedirect>
        <HoneybadgerErrorBoundary honeybadger={honeybadger}>
            <App />
        </HoneybadgerErrorBoundary>
    </HttpsRedirect>,
    document.getElementById('root')
);
